import StatusType from './status-type'

export default {
  TO_MANAGE: { id: 1, status: [StatusType.SUITABLE] },
  IN_PROGRESS: { id: 2, status: [StatusType.CITED, StatusType.TO_BE_CONFIRMED, StatusType.CONFIRMED, StatusType.RESCHEDULE, StatusType.CITED_PHASE_2, StatusType.DOC_REQUIRED, StatusType.DOC_RECEIVED, StatusType.PENDING_UPDATE] },
  FINALISTS: { id: 3, status: [StatusType.BOOKING] }
  //OTHERS: { id: 4, status: [StatusType.NOT_INTERESTED, StatusType.NOT_ATTEND, StatusType.DISCARDED, StatusType.NOT_INTERESTED_PHASE_2] }
}
